/// <reference path="typings/Text.d.ts"/>
import global from "./global";

declare var TextEntries: TextEntry[];

TextEntries.forEach(entry => (global as any)[entry.Name] = entry.Values);
